var map = {
	"./AC.png": 56173,
	"./AD.png": 53047,
	"./AG.png": 99620,
	"./AI-alt.png": 10909,
	"./AL.png": 46348,
	"./AM.png": 5937,
	"./AO.png": 19227,
	"./AQ.png": 16541,
	"./AR.png": 57147,
	"./AS.png": 34485,
	"./AT.png": 75860,
	"./AW.png": 81386,
	"./AX.png": 40246,
	"./AZ.png": 66833,
	"./Afghanistan.png": 69490,
	"./Africa.png": 23106,
	"./Albania.png": 86493,
	"./Algeria.png": 86660,
	"./Arabic.png": 72182,
	"./Australia.png": 38848,
	"./BA.png": 15528,
	"./BB.png": 81150,
	"./BD.png": 59145,
	"./BF.png": 24766,
	"./BG.png": 55204,
	"./BH.png": 89895,
	"./BI.png": 53521,
	"./BJ.png": 90305,
	"./BL.png": 72233,
	"./BM.png": 71758,
	"./BN.png": 71750,
	"./BO-alt.png": 6436,
	"./BO.png": 56026,
	"./BQ.png": 1424,
	"./BS.png": 96425,
	"./BT.png": 22543,
	"./BV.png": 74722,
	"./BW.png": 30536,
	"./BY-alt.png": 79962,
	"./BY.png": 10451,
	"./BZ.png": 12769,
	"./Belgium.png": 30418,
	"./Brazil.png": 45262,
	"./CC.png": 28703,
	"./CD.png": 3445,
	"./CF.png": 46133,
	"./CG.png": 65826,
	"./CH.png": 94278,
	"./CI.png": 40931,
	"./CK.png": 68986,
	"./CL.png": 63122,
	"./CM.png": 72609,
	"./CN.png": 85271,
	"./CO.png": 26650,
	"./CP.png": 84212,
	"./CR.png": 74521,
	"./CU.png": 15496,
	"./CV.png": 20479,
	"./CW.png": 45768,
	"./CX.png": 36797,
	"./CY.png": 32832,
	"./CZ.png": 50521,
	"./Canada French.png": 48693,
	"./Canada.png": 65390,
	"./Caribbean.png": 26031,
	"./DG-alt.png": 5446,
	"./DG.png": 3176,
	"./DJ.png": 68056,
	"./DK.png": 10011,
	"./DM.png": 61011,
	"./DO.png": 1166,
	"./EA-alt.png": 61800,
	"./EA.png": 88060,
	"./EC.png": 74564,
	"./EE.png": 2779,
	"./EG.png": 60127,
	"./EH.png": 85877,
	"./ER.png": 8098,
	"./ET.png": 17485,
	"./EU.png": 49717,
	"./EX-USSR.png": 56909,
	"./EX-YU.png": 11134,
	"./FI.png": 627,
	"./FJ.png": 38464,
	"./FK.png": 93481,
	"./FM.png": 9961,
	"./FO.png": 7845,
	"./Filipino.png": 11944,
	"./France.png": 85641,
	"./GA.png": 79488,
	"./GD.png": 85661,
	"./GE.png": 16510,
	"./GF.png": 47699,
	"./GG.png": 19289,
	"./GH.png": 60280,
	"./GI.png": 48093,
	"./GL.png": 85201,
	"./GM.png": 37243,
	"./GN.png": 96087,
	"./GP-alt.png": 21411,
	"./GP.png": 37553,
	"./GQ.png": 98541,
	"./GS.png": 87928,
	"./GT.png": 77099,
	"./GU.png": 91374,
	"./GW.png": 42433,
	"./GY.png": 80459,
	"./Germany.png": 73990,
	"./Greece.png": 1250,
	"./HK.png": 75892,
	"./HM.png": 87958,
	"./HN.png": 48469,
	"./HR.png": 86199,
	"./HT.png": 44206,
	"./HU.png": 57546,
	"./IC.png": 76160,
	"./ID.png": 40355,
	"./IE.png": 36551,
	"./IM.png": 22977,
	"./IO.png": 61337,
	"./IQ.png": 83152,
	"./IR.png": 50407,
	"./IS.png": 36679,
	"./India.png": 49448,
	"./Israel.png": 53948,
	"./Italy.png": 38900,
	"./JE.png": 89690,
	"./JM.png": 46875,
	"./JO.png": 44800,
	"./JP.png": 39667,
	"./KE.png": 19809,
	"./KG.png": 9541,
	"./KH.png": 86688,
	"./KI.png": 48225,
	"./KM.png": 79380,
	"./KN.png": 12094,
	"./KP.png": 51015,
	"./KR.png": 84504,
	"./KW.png": 23497,
	"./KY.png": 78752,
	"./KZ.png": 8694,
	"./LA.png": 99625,
	"./LB.png": 70569,
	"./LC.png": 98053,
	"./LI.png": 98039,
	"./LK.png": 15917,
	"./LR.png": 92495,
	"./LS.png": 11728,
	"./LT.png": 52474,
	"./LU.png": 64424,
	"./LV.png": 4929,
	"./LY.png": 5824,
	"./MA.png": 43309,
	"./MC.png": 90485,
	"./MD.png": 81723,
	"./ME.png": 53817,
	"./MF.png": 80190,
	"./MG.png": 89365,
	"./MH.png": 44878,
	"./ML.png": 40467,
	"./MM.png": 7055,
	"./MN.png": 32072,
	"./MO.png": 39719,
	"./MP.png": 99194,
	"./MQ.png": 33621,
	"./MR.png": 60146,
	"./MS.png": 45455,
	"./MT.png": 50606,
	"./MU.png": 61879,
	"./MV.png": 87404,
	"./MW.png": 67035,
	"./MX.png": 27224,
	"./MY.png": 45793,
	"./MZ.png": 99400,
	"./Macedonia.png": 87374,
	"./NA.png": 11438,
	"./NC-alt.png": 53609,
	"./NC.png": 95767,
	"./NE.png": 11077,
	"./NF.png": 7065,
	"./NG.png": 66807,
	"./NI.png": 44275,
	"./NO.png": 52616,
	"./NP.png": 60270,
	"./NR.png": 67853,
	"./NU.png": 63955,
	"./NZ.png": 76507,
	"./Netherlands.png": 85328,
	"./OM.png": 72776,
	"./PA.png": 10728,
	"./PE-alt.png": 43690,
	"./PE.png": 73697,
	"./PF.png": 98114,
	"./PG.png": 26167,
	"./PK.png": 6909,
	"./PM.png": 24129,
	"./PN.png": 22383,
	"./PR.png": 89447,
	"./PS.png": 51857,
	"./PW.png": 52577,
	"./PY.png": 55754,
	"./Poland.png": 71236,
	"./Portuguese.png": 35125,
	"./QA.png": 85261,
	"./RE.png": 71896,
	"./RS.png": 72669,
	"./RW.png": 16861,
	"./Romania.png": 50646,
	"./Russia.png": 1019,
	"./SA-alt.png": 14821,
	"./SA.png": 19849,
	"./SB.png": 83920,
	"./SC.png": 70910,
	"./SD.png": 60809,
	"./SE.png": 74250,
	"./SG.png": 2778,
	"./SH.png": 91253,
	"./SI.png": 26224,
	"./SJ-alt.png": 69642,
	"./SJ.png": 38123,
	"./SK.png": 90948,
	"./SL.png": 7288,
	"./SM.png": 99544,
	"./SN.png": 59425,
	"./SO.png": 13450,
	"./SR.png": 32215,
	"./SS.png": 64530,
	"./ST.png": 73636,
	"./SV.png": 73543,
	"./SX.png": 71455,
	"./SY.png": 19322,
	"./SZ.png": 26262,
	"./Spain.png": 30684,
	"./TA.png": 84931,
	"./TC.png": 71999,
	"./TD.png": 12948,
	"./TF.png": 4093,
	"./TG.png": 2104,
	"./TH.png": 60229,
	"./TJ.png": 79846,
	"./TK.png": 6974,
	"./TL.png": 82197,
	"./TM.png": 53690,
	"./TN.png": 48148,
	"./TO.png": 54751,
	"./TR.png": 17657,
	"./TT.png": 80997,
	"./TV.png": 58796,
	"./TW-alt.png": 84945,
	"./TW.png": 1839,
	"./TZ.png": 76405,
	"./UA.png": 42106,
	"./UG.png": 69136,
	"./UK.png": 20986,
	"./UM-alt.png": 2211,
	"./UM.png": 81708,
	"./UN.png": 92697,
	"./US Local.png": 20858,
	"./US.png": 2931,
	"./UY.png": 13881,
	"./UZ.png": 17789,
	"./VA.png": 4907,
	"./VC.png": 20080,
	"./VE-alt.png": 20495,
	"./VE.png": 43332,
	"./VG.png": 26769,
	"./VI.png": 58934,
	"./VN.png": 11019,
	"./VU.png": 70460,
	"./WF.png": 20648,
	"./WS.png": 98604,
	"./XK.png": 27422,
	"./YE.png": 70723,
	"./YT.png": 17127,
	"./ZM.png": 91795,
	"./ZW.png": 81216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83546;